import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import axios from 'axios'
import './Login.css' // Import your CSS file
import { FaEye, FaEyeSlash } from 'react-icons/fa' // Using react-icons for the eye icon
import { ViewIcon } from '../Icons'

function Login() {
  const navigate = useNavigate()
  const [errorMessage, setErrorMessage] = useState('') // State for error message
  const [showPassword, setShowPassword] = useState(false) // State for password visibility

  const [values, setValues] = useState({
    email: '',
    password: '',
  })
  const handleSubmit = async (e) => {
    e.preventDefault()
    setErrorMessage('') // Clear previous error message
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}login`,
        {
          ...values,
        },
        {
          withCredentials: true,
        }
      )
      localStorage.setItem('token', data.token)
      localStorage.setItem('userid', data.user._id)
      localStorage.setItem('timeroptions', data.user.timeroptions)
      localStorage.setItem('role', data.user.role)
      localStorage.setItem('first_name', data.user.first_name)
      localStorage.setItem('last_name', data.user.last_name)
      if (data.user.role == 'admin' || data.user.role == 'subadmin')
        navigate('/dashboard')
      else if (data.user.role == 'parent') {
        // Fetch students for parent and redirect to first student's practice tests
        const students = data.user.students || []
        if (students.length > 0) {
          navigate(`/practice_tests?student_id=${students[0]._id}`)
        } else {
          navigate('/practice_tests')
        }
      } else navigate('/practice_tests')
      window.location.reload(true)
    } catch (error) {
      if (error.response) {
        const errorMessage =
          error.response.data.message ||
          'Invalid login details. Please try again.'
        setErrorMessage(errorMessage) // Set error message
      } else if (error.request) {
        setErrorMessage(
          'No response from the server. Please check your internet connection.'
        )
      } else {
        setErrorMessage('An unexpected error occurred. Please try again later.')
      }
    }
  }

  // jwt validation

  const [cookies, setCookies] = useCookies([])
  useEffect(() => {
    const verifyUser = async () => {
      if (cookies.jwt) {
        navigate('/home')
      } else {
        navigate('/')
      }
    }
    verifyUser()
  }, [cookies, navigate])

  return (
    <>
      <div style={{ position: 'absolute', top: 24, left: 24, zIndex: 10 }}>
        <img src="/logo.png" alt="Brilliant Prep" style={{ height: 48 }} />
      </div>
      <div class="login-container">
        <div class="image-div">
          <div>
            <img src="/images/login_Illustration.svg" />
          </div>
        </div>
        <div class="form-div">
          <div class="form-container">
            <div class="form-header">Sign In</div>
            <a href="#" class="signup-link">
              <span>No account yet?</span> Sign up →
            </a>
            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
            <form autoComplete="off" onSubmit={(e) => handleSubmit(e)}>
              <div class="inputBox">
                <input
                  placeholder="Email"
                  id="uname"
                  type="email"
                  name="email"
                  onChange={(e) =>
                    setValues({ ...values, [e.target.name]: e.target.value })
                  }
                />

                <div class="textbox-container password-field">
                  <input
                    placeholder="Password"
                    id="pass"
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    onChange={(e) =>
                      setValues({ ...values, [e.target.name]: e.target.value })
                    }
                  />
                  <span
                    class="toggle-password"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    <ViewIcon />
                  </span>
                </div>
              </div>

              <div class="options">
                <label>
                  <input type="checkbox" class="forgot_chkbox" /> Remember me
                </label>
              </div>

              <div class="login-btn">
                <input type="submit" value="Sign In" />
              </div>

              <div class="forgotpassword">
                <a
                  href="#"
                  class="forgot-link"
                  style={{
                    color: 'var(--Grey, #626262)',
                    fontFamily: 'Basis Grotesque Pro',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '130%',
                    letterSpacing: '0.16px',
                  }}
                >
                  Forgot Password?
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default Login
